var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pageNews.length
    ? _c("div", [
        _c(
          "div",
          { staticClass: "page-blog" },
          [
            _c(
              "v-container",
              [
                _c("div", { staticClass: "page-blog__title" }, [
                  _c("i", { staticClass: "icon-blog" }),
                  _c("div", { staticClass: "text" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.$t("front.news.page.title")))]),
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("front.news.page.description")))
                    ])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "page-blog__list" },
                  _vm._l(_vm.pageNews, function(item) {
                    return _c("div", { staticClass: "item" }, [
                      _c(
                        "div",
                        { staticClass: "item__image" },
                        [
                          _c("router-link", { attrs: { to: item.pageUrl } }, [
                            _c(
                              "picture",
                              [
                                _vm._l(
                                  item[
                                    _vm.isDeviceMobile
                                      ? "mobileImage"
                                      : "desktopImage"
                                  ].sourcesTypes,
                                  function(sourceType, index) {
                                    return _c("source", {
                                      key: index,
                                      attrs: {
                                        srcset:
                                          item[
                                            _vm.isDeviceMobile
                                              ? "mobileImage"
                                              : "desktopImage"
                                          ][sourceType],
                                        type: "image/" + sourceType
                                      }
                                    })
                                  }
                                ),
                                _c("img", {
                                  attrs: {
                                    src:
                                      item[
                                        _vm.isDeviceMobile
                                          ? "mobileImage"
                                          : "desktopImage"
                                      ].jpg,
                                    alt: item.title
                                  }
                                })
                              ],
                              2
                            )
                          ])
                        ],
                        1
                      ),
                      _c("div", { staticClass: "item__content" }, [
                        _c(
                          "div",
                          { staticClass: "item__content-top" },
                          [
                            _c("h2", {
                              domProps: { textContent: _vm._s(item.title) }
                            }),
                            _c(
                              "router-link",
                              { attrs: { to: item.categoryPageUrl } },
                              [_vm._v(_vm._s(item.categoryTitle))]
                            )
                          ],
                          1
                        ),
                        _c("div", {
                          staticClass: "item__content-desc",
                          domProps: {
                            textContent: _vm._s(item.shortDescription)
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "item__content-bottom" },
                          [
                            _c("router-link", { attrs: { to: item.pageUrl } }, [
                              _vm._v(
                                _vm._s(_vm.$t("front.news.button.read_more"))
                              )
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  }),
                  0
                ),
                _c("query-string-paginator", {
                  attrs: { length: _vm.totalPages, "links-count": 8 },
                  on: { change: _vm.changePage },
                  model: {
                    value: _vm.page,
                    callback: function($$v) {
                      _vm.page = $$v
                    },
                    expression: "page"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }